"use strict";import{IconHeart as e}from"../src/elements/IconHeart.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-heart",e);
//# sourceMappingURL=sp-icon-heart.js.map
